module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_10_sp-cfa2b5e65b5795a05d9ab0a26f98b08b.png";